import { render, staticRenderFns } from "./VerticalTab.vue?vue&type=template&id=79798c03"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"
import style0 from "./VerticalTab.vue?vue&type=style&index=0&id=79798c03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports